import { createUseStyles } from "react-jss";
import { colors } from "../../../../styles/colors";
const useStyles = createUseStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    minWidth: "187px",
    borderRadius: "15px",
    backgroundColor: colors.surface,
    border: `1px solid ${colors.borderLight}`,
    padding: "20px",
    height: "fit-content",
  },
  containerHeader: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: "4px",
  },
  docCount: {
    fontSize: "12px",
    fontWeight: 500,
    color: colors.textSecondary || "#888",
    backgroundColor: colors.borderLight || "#f0f0f0",
    padding: "2px 8px",
    borderRadius: "10px",
  },
  subContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 10px",
    borderRadius: "10px",
    transition: "background-color 0.15s ease",
    gap: "8px",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.03)",
    },
  },
  docAvailable: {
    borderLeft: `3px solid ${colors.success || "#4caf50"}`,
  },
  docMissing: {
    borderLeft: `3px solid ${colors.warning || "#ff9800"}`,
  },
  subContainer2: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
    minWidth: 0,
    flex: 1,
  },
  docInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    minWidth: 0,
  },
  statusUploaded: {
    fontSize: "11px",
    fontWeight: 500,
    color: colors.success || "#4caf50",
  },
  statusMissing: {
    fontSize: "11px",
    fontWeight: 500,
    color: colors.warning || "#ff9800",
  },
  actionButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "4px",
    flexShrink: 0,
  },
  contratTitle: {
    color: colors.primary,
  },
  iconButton: {
    margin: 0,
    padding: "4px",
  },
});

export default useStyles;